import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useFinca } from '../context/FincaContext';
import { usePermisos } from '../context/PermisosContext';
import Sectores from './Sectores';
import Piscina from './Piscina';
import Usuarios from './Usuarios';
import Permisos from './Permisos';
import ImportarDatos from './ImportarDatos';
import Fincas from './Fincas';
import Recursos from './configuracion/Recursos';

// Pestañas provenientes del módulo Alimentación
import TiposAlerta from './alimentacion/TiposAlerta';
import Diagnosticos from './alimentacion/Diagnosticos';

export default function Configuracion() {
  const { usuario } = useAuth();
  const { esSuperAdmin } = useFinca();
  const { tienePermiso } = usePermisos();

  const esSuperAdminLocal = usuario?.rol === 'super_admin' || esSuperAdmin;

  const todas = [
    { id: 'sectores',      label: 'Sectores',         icon: '📁', permiso: 'configuracion.sectores' },
    { id: 'piscina',       label: 'Piscinas',         icon: '🗾', permiso: 'configuracion.piscinas' },
    { id: 'usuarios',      label: 'Usuarios',         icon: '👥', permiso: 'configuracion.usuarios' },
    { id: 'roles',         label: 'Roles y Permisos', icon: '🔐', permiso: 'configuracion.roles' },
    { id: 'importar',      label: 'Importar Datos',   icon: '📥', permiso: 'configuracion.importar' },
    { id: 'fincas',        label: 'Fincas',           icon: '🏢', permiso: 'configuracion.fincas', soloSuperAdmin: true },

    // Módulo Alimentación
    { id: 'tipos-alerta',  label: 'Tipos de Alerta',  icon: '🏷️', permiso: 'alimentacion.tipos-alerta' },
    { id: 'diagnosticos',  label: 'Diagnósticos',     icon: '🩺', permiso: 'alimentacion.diagnosticos' },

    // Recursos (tipos de balanceado)
    { id: 'recursos',      label: 'Recursos',         icon: '🧰', permiso: 'configuracion.recursos' },
  ];

  const pestanas = todas.filter(p => {
    if (p.soloSuperAdmin && !esSuperAdminLocal) return false;
    return tienePermiso(p.permiso);
  });

  const [pestanaActiva, setPestanaActiva] = useState(pestanas[0]?.id || '');

  useEffect(() => {
    if (pestanas.length && !pestanas.some(p => p.id === pestanaActiva)) {
      setPestanaActiva(pestanas[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pestanas.length]);

  if (pestanas.length === 0) {
    return (
      <div className="p-6 text-center text-gray-500">
        No tienes permiso para ninguna sección de configuración.
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="bg-white border-b shadow-sm">
        <div className="px-6 py-5">
          <h1 className="text-3xl font-bold text-primary mb-4 text-center">Configuración</h1>
          <div className="flex gap-2 flex-wrap justify-center">
            {pestanas.map((p) => {
              const activa = pestanaActiva === p.id;
              return (
                <button
                  key={p.id}
                  onClick={() => setPestanaActiva(p.id)}
                  className={`px-4 py-2 text-sm font-medium rounded-lg transition border-2 flex items-center gap-2 ${
                    activa
                      ? 'text-white bg-primary border-primary shadow-md'
                      : 'text-gray-600 bg-white border-gray-300 hover:border-primary hover:text-primary hover:bg-blue-50'
                  }`}
                >
                  <span className="text-base">{p.icon}</span>
                  <span>{p.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-auto bg-gray-100">
        {pestanaActiva === 'sectores'     && <Sectores />}
        {pestanaActiva === 'piscina'      && <Piscina />}
        {pestanaActiva === 'usuarios'     && <Usuarios />}
        {pestanaActiva === 'roles'        && <Permisos />}
        {pestanaActiva === 'importar'     && <ImportarDatos />}
        {pestanaActiva === 'fincas'       && esSuperAdminLocal && <Fincas />}
        {pestanaActiva === 'tipos-alerta' && <TiposAlerta />}
        {pestanaActiva === 'diagnosticos' && <Diagnosticos />}
        {pestanaActiva === 'recursos'     && <Recursos />}
      </div>
    </div>
  );
}